// src/components/layout/Layout.tsx
//
// Main app layout: Header + main content area + Footer.
// Used as the wrapper for all routes.
//
// We wrap public routes with this layout and use <Outlet /> to
// render the matched child route. Admin and portal have their own
// layouts with their own <Outlet /> wrappers (they add sidebar nav
// on top of the main area).

import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BenchmarkWatermark } from "./BenchmarkWatermark";
import { TeddyChatKit } from "@/components/agent/TeddyChatKit";
import { ImportProgressChip } from "@/components/imports/ImportProgressChip";
import { TeddyNudge } from "@/components/notifications/TeddyNudge";

/**
 * The main app layout.
 * Sticky header, content area with vertical padding, footer.
 */
export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-surface-canvas">
      <BenchmarkWatermark intensity="normal" />
      <div className="relative z-10 flex min-h-screen flex-col">
        <Header />
        <ImportProgressChip />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <TeddyChatKit />
      <TeddyNudge />
    </div>
  );
}